// eslint-disable-next-line no-restricted-imports
import { Dialog } from '@mui/material';
// eslint-disable-next-line no-restricted-imports
export type { DialogProps as MuiDialogProps } from '@mui/material';

export const MuiDialog = Dialog;
